import { useGetQuery, usePostMutation } from "slices/api";

const useFireSafetybuildingInfoQuery = (query = {}) =>
  useGetQuery({
    endpoint: "/building-information/list",
    query,
    tags: [],
  });

const usePostBuildingSendMailMutation = () => {
  const [sendBuildingMail, data] = usePostMutation();
  const setSendBuildingMail = async (payload) =>
    await sendBuildingMail({
      endpoint: "/building-information/send-mail",
      payload: payload || {},
      toastMessage: "Email Sent successfully",
      tags: [],
    }).unwrap();
  return [setSendBuildingMail, data];
};

export { useFireSafetybuildingInfoQuery, usePostBuildingSendMailMutation };
